var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"button-style",attrs:{"fab":"","fixed":"","large":"","dark":"","bottom":"10","right":"10","color":"#ff6347"},on:{"click":_vm.onClick}},on),[_c('v-icon',[_vm._v("mdi-email-multiple")])],1)]}}])},[_c('span',[_vm._v("気になるお仕事にまとめて応募する")])])}
var staticRenderFns = []

export { render, staticRenderFns }